import React from "react";
import Reveal from "../site/Reveal";
import { SectionLabel, ArrowLink } from "../site/Bits";
import { COLLABORATION } from "../../lib/content";
import { IMAGES } from "../../lib/images";

/**
 * Home-page collaboration band: LYKIT ENTERTAINMENT x IBMCT.
 * Sits between "More Than Entertainment" and "What We Do".
 */
export default function CollaborationBand() {
  return (
    <section
      style={{ background: "var(--lykit-lavender)" }}
      data-testid="home-collaboration-section"
      id="collaborations"
    >
      <div className="lk-container-wide py-[clamp(36px,3.4vw,60px)]">
        <div className="grid items-center gap-y-8 lg:grid-cols-12 lg:gap-x-14">
          <Reveal variant="image" className="lg:col-span-5">
            <figure
              className="img-frame img-zoom relative w-full"
              style={{ aspectRatio: "4 / 3", border: "1px solid rgba(23,21,34,0.10)", margin: 0 }}
            >
              <img
                src={IMAGES.collaboration.ibmct}
                alt="LYKIT Entertainment and IBMCT collaboration announcement"
                data-testid="home-collaboration-image"
                loading="lazy"
              />
            </figure>
          </Reveal>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <SectionLabel>Collaborations</SectionLabel>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="display-lg mt-4" data-testid="home-collaboration-title">
                <span className="block">LYKIT ENTERTAINMENT</span>
                <span className="flex items-baseline gap-3">
                  <span
                    className="editorial-sm"
                    style={{ color: "#B08A4B", fontSize: "0.86em", lineHeight: 1 }}
                    aria-hidden="true"
                  >
                    &#215;
                  </span>
                  <span style={{ color: "#352A59" }}>IBMCT</span>
                </span>
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="lead measure mt-5" data-testid="home-collaboration-note">
                {COLLABORATION.shortNote}
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <ul
                className="mt-7 grid gap-x-8 gap-y-0 sm:grid-cols-3"
                style={{ listStyle: "none", margin: 0, padding: 0 }}
              >
                {COLLABORATION.points.map((point) => (
                  <li
                    key={point.title}
                    className="py-[10px]"
                    style={{ borderTop: "1px solid rgba(23,21,34,0.12)" }}
                  >
                    <span className="display-sm block">{point.title}</span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.26}>
              <div className="mt-8 flex flex-wrap items-center gap-x-9 gap-y-4">
                <ArrowLink to="/partners" data-testid="home-collaboration-cta">
                  Explore The Collaboration
                </ArrowLink>
                <ArrowLink
                  href={COLLABORATION.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="home-collaboration-ibmct-link"
                >
                  {COLLABORATION.linkLabel}
                </ArrowLink>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
